export type InsertMediaData = {
  html: string
  url: string
  ratio: string
}

export type InsertMediaPrecursor = {
  url: string
  ratio: string
}
